import { render } from "./RulesModal.vue?vue&type=template&id=79493b80&scoped=true"
import script from "./RulesModal.vue?vue&type=script&lang=js"
export * from "./RulesModal.vue?vue&type=script&lang=js"

import "./RulesModal.vue?vue&type=style&index=0&id=79493b80&scoped=true&lang=css"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79493b80"]])

export default __exports__